import { Text } from '@chakra-ui/react';

import Link from '../Link';

export const ContactError: React.FC = () => (
  <Text>
    Please try again in a few minutes. If the issue persists,{' '}
    <Link
      textDecoration="underline"
      fontWeight="500"
      color="black"
      href="mailto:support@whalar.com"
    >
      contact us
    </Link>
    .
  </Text>
);
